import { NgModule } from '@angular/core';
import { FinitoSharedLibsModule } from './shared-libs.module';
import { FindLanguageFromKeyPipe } from './language/find-language-from-key.pipe';
import { JhiAlertComponent } from './alert/alert.component';
import { JhiAlertErrorComponent } from './alert/alert-error.component';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import {TranslateModule} from "@ngx-translate/core";
import { SharedStandaloneModule } from './shared-standalone.module';
@NgModule({
  imports: [FinitoSharedLibsModule, SharedStandaloneModule],
  declarations: [FindLanguageFromKeyPipe, JhiAlertComponent, JhiAlertErrorComponent],
  exports: [FinitoSharedLibsModule, FindLanguageFromKeyPipe, JhiAlertComponent, JhiAlertErrorComponent, SharedStandaloneModule, TranslateModule]
})
export class FinitoSharedModule {}
